import React, { useState, useContext, Fragment } from 'react'
import { UserContext } from '../../../context/UserContext'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { BiDotsVertical } from 'react-icons/bi'
import { AnimatePresence } from 'framer-motion'
import { DeleteFitnessListing } from './DeleteFitnessListing'
import { openModal } from '../../../service/modal-service'
import { renewFitnessListing, updateFitnessListingActiveInd } from '../../../api/personal-trainer/personal-trainer-api'
import { SystemError } from '../../error/SystemError'
import { FaHeart } from 'react-icons/fa'

export const PersonalTrainerPackage = (props) => {
    const listing = props.listing
    const stringsUserId = props.stringsUserId
    const getListings = props.getListings

    const [ editlistingId, setEditListingId ] = useState(false)
    const [ isShowDeleteListing, setIsShowDeleteListing ] = useState(false)

    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""});

    const { userId } = useContext(UserContext)

    const deleteListing = (listingId) => {
        setEditListingId(listingId)
        openModal(setIsShowDeleteListing)
    }

    const renewListing = async(listingId) => {
        setEditListingId(listingId)

        try {
            await renewFitnessListing(userId, listingId)
            getListings()
        } catch (error) {
            console.log(error);
            setErrorContent({'header': "Error renewing package", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true)
            setIsUploading(false)
            return
        }
    }

    const activateListing = async(listingId, activeInd) => {
        setEditListingId(listingId)
        
        try {
            await updateFitnessListingActiveInd(userId, listingId, activeInd)
            getListings()
        } catch (error) {
            console.log(error);
            setErrorContent({'header': "Error updating active indicator", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true)
            setIsUploading(false)
            return
        }
    }

  return (
    <>
        <div className='px-2'>        
            <div className='flex justify-between items-center'>
                <h1 className='text-orange-600 font-bold'>{listing.title}</h1>
                {userId === stringsUserId && 
                    <Menu as="div" className="relative text-orange-600 text-xl md:text-2xl">
                        <MenuButton className="p-2 focus:outline-none">
                            <BiDotsVertical/>
                        </MenuButton>
                        <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-y-0"
                        enterTo="transform opacity-100 scale-y-100"
                        leave="transition ease-in duration-200"
                        leaveFrom="transform opacity-100 scale-y-100"
                        leaveTo="transform opacity-0 scale-y-0"
                        >
                            <MenuItems className='absolute right-5 w-28 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none'>
                                <MenuItem className="text-xs text-orange-600 w-full">
                                    {listing.activeInd === "Y" ?
                                        <button type="button" onClick={() => activateListing(listing.listingId, "N")}>
                                            <span className='flex justify-center px-3 py-3'>
                                                De-Activate
                                            </span>
                                        </button>
                                        :
                                        <button type="button" onClick={() => activateListing(listing.listingId, "Y")}>
                                            <span className='flex justify-center px-3 py-3'>
                                                Activate
                                            </span>
                                        </button>
                                    }
                                </MenuItem>
                                {listing.daysToExpiry < 15 &&                            
                                    <Menu.Item className="text-xs text-orange-600 w-full" >
                                        <button type="button" onClick={() => renewListing(listing.listingId)}>
                                            <span className='flex justify-center px-3 py-3'>
                                                Renew
                                            </span>
                                        </button>
                                    </Menu.Item>
                                }
                                <MenuItem className="text-xs text-orange-600 w-full" >
                                    <button type="button" onClick={() => deleteListing(listing.listingId)}>
                                        <span className='flex justify-center px-3 py-3'>
                                            Delete
                                        </span>
                                    </button>
                                </MenuItem>
                            </MenuItems>
                        </Transition>
                    </Menu>
                }
            </div>
            <div className='mt-3'>
                {userId === stringsUserId &&
                    <div className='flex justify-between items-center py-2 text-2xs text-white space-x-2'>
                        <div className='flex space-x-2'>
                            {listing.activeInd === "Y" ?
                                <div >
                                    <span className='px-2 py-1 bg-green-600  rounded-full'>
                                        active
                                    </span>
                                </div>
                                :
                                <div>
                                    <span className='px-2 py-1 bg-amber-700 rounded-full'>
                                        inactive
                                    </span>
                                </div>
                            }
                            {(listing.corporateInd === "Y" || listing.type === "Corporate") &&
                                <div >
                                    <span className='px-2 py-1 bg-blue-600  rounded-full'>
                                        corporate
                                    </span>
                                </div>
                            }
                            {listing.daysToExpiry > 14 ?
                                <div>
                                    <span className='px-2 py-1 bg-green-600  rounded-full'>
                                        Expires - {listing.expiryDate}
                                    </span>
                                </div>
                                :
                                <>
                                    {listing.daysToExpiry < 0 ? 
                                        <div>
                                            <span className='px-2 py-1 bg-red-600  rounded-full'>
                                                Expired - {listing.expiryDate}
                                            </span>
                                        </div>
                                        :
                                        <div>
                                            <span className='px-2 py-1 bg-amber-600  rounded-full'>
                                                Expires - {listing.expiryDate}
                                            </span>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        <div className="flex justify-end items-center text-sm"><span className='text-orange-600'>{listing.interestCount}&nbsp;</span> 
                                <FaHeart className='text-base text-red-500'/>
                        </div>
                    </div>
                }
                <div className='flex items-center text-sm '>
                    <span className='font-bold text-gray-500'>Package Period: &nbsp;</span>
                    {(listing.type == 'Free Trial' || listing.type == 'One-time') ?
                    (
                        <div className='text-orange-600'>
                            {listing.type}
                        </div>
                    )    
                        :
                    (
                        <div className='text-orange-600'>
                            <span>{listing.unitQuantity}&nbsp;
                                {(listing.type == 'Standard' || listing.type == 'Corporate') &&
                                    <span>Session/s</span>
                                }
                                {listing.type == 'Hourly' &&
                                    <span>Hour/s</span>
                                }
                                {listing.type == 'Weekly' &&
                                    <span>Week/s</span>
                                }
                                {listing.type == 'Monthly' &&
                                    <span>Month/s</span>
                                }
                            </span>
                        </div>
                    )
                    }  
                </div>
                <div className='text-sm'>
                    {listing.type == 'Weekly' &&
                        <div>
                            <span className='text-gray-500 font-bold'>Session per week: &nbsp;</span><span className='text-orange-600'>{listing.sessionCount}</span>
                        </div>
                        
                    }
                    {listing.type == 'Monthly' &&
                        <div>
                            <span className='text-gray-500 font-bold'>Session per month: &nbsp;</span><span className='text-orange-600'>{listing.sessionCount}</span>
                        </div>
                    }
                </div>
                <div className='text-sm'>
                    <span className='text-gray-500 font-bold'>Package cost: &nbsp;</span><span className='text-orange-600'>{listing.currencyCd} {listing.cost}</span>
                    {listing.originalCost > 0 &&
                        <span className='text-gray-500'>/<del>{listing.currencyCd} {listing.originalCost}</del></span>
                    }
                    <br/><span className='text-orange-600'>({listing.currencyCd} {listing.perSession} per session)</span>                                                                
                </div>
                <div className='text-sm my-2'>
                    <span className='text-gray-500 whitespace-pre-wrap leading-6'>{listing.description}</span>                                                                                                                      
                </div>
            </div>
        </div>
        <AnimatePresence>
            {isShowDeleteListing && 
                <DeleteFitnessListing editlistingId={editlistingId} getListings={getListings}/>
            }
        </AnimatePresence>
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </>
  )
}
